/* import __COLOCATED_TEMPLATE__ from './button-description.hbs'; */
import Component from '@glimmer/component';
import { ButtonDescription as ButtonDescriptionProto } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
import bbFrontendGlyphIconToSvg from '@banking/ui/utils/bb-frontend-glyph-icon-to-svg';
function convertStyleEnumToString(style) {
  switch (style) {
    case ButtonDescriptionProto.ButtonStyle.BUTTON_STYLE_PRIMARY:
      return 'primary';
    case ButtonDescriptionProto.ButtonStyle.BUTTON_STYLE_SECONDARY:
      return 'secondary';
    case ButtonDescriptionProto.ButtonStyle.BUTTON_STYLE_DEFERRED:
    default:
      return '';
  }
}
function convertVariantEnumToString(variant) {
  switch (variant) {
    case ButtonDescriptionProto.ButtonVariant.BUTTON_VARIANT_NORMAL:
      return 'regular';
    case ButtonDescriptionProto.ButtonVariant.BUTTON_VARIANT_DESTRUCTIVE:
      return 'destructive';
    case ButtonDescriptionProto.ButtonVariant.BUTTON_VARIANT_DEFERRED:
    default:
      return '';
  }
}
export default class ButtonDescription extends Component {
  get rank() {
    return convertStyleEnumToString(this.args.buttonDescription.style);
  }
  get variant() {
    return convertVariantEnumToString(this.args.buttonDescription.variant);
  }
  get icon() {
    if (this.args.buttonDescription.icon) {
      return bbFrontendGlyphIconToSvg(this.args.buttonDescription.icon);
    } else {
      return null;
    }
  }
  get iconClass() {
    if (this.args.buttonDescription.style === ButtonDescriptionProto.ButtonStyle.BUTTON_STYLE_SECONDARY) {
      return 'banking__button-description__svg--secondary';
    } else {
      return 'banking__button-description__svg--primary';
    }
  }
}